export default __webpack_public_path__ + "static/per-marker-customisation-dc48008883552e9f4b162e513662a69c.png";